import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'default' | 'lg';
  withIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'default',
  withIcon = false,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1B4332] disabled:opacity-50 disabled:pointer-events-none rounded-xl cursor-pointer no-underline';
  const variants = {
    primary: 'bg-[#1B4332] text-white hover:bg-[#2D6A4F] shadow-lg shadow-[#1B4332]/20',
    secondary: 'bg-[#D8F3DC] text-[#1B4332] hover:bg-[#C1EAC5]',
    outline: 'border-2 border-[#1B4332] text-[#1B4332] hover:bg-[#F0FDF4]'
  };
  const sizes = {
    default: 'h-12 px-6 py-3 text-base',
    lg: 'h-14 px-8 py-4 text-lg'
  };
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Fire Meta Pixel AddToCart event
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Rodilla Sin Miedo',
        content_type: 'product',
        currency: 'ARS',
        value: 9300
      });
    }
    if (onClick) onClick(e);
  };
  return <motion.a whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} href="https://argrutinas.com/cart/42966488416465:1" target="_blank" rel="noopener noreferrer" className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} onClick={handleClick} {...props} data-id="element-231">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-232" />}
    </motion.a>;
}